/**
 * Error tag parser for extracting contract-defined error messages.
 *
 * Contracts can define custom error messages using:
 *   {{errors {"1": "Board is read-only", "7": "Flair required for posts"}}}
 *
 * These mappings allow the viewer to display user-friendly error messages
 * when contract errors occur, instead of showing raw error codes.
 */
// Regex to match {{errors {...}}}
// Captures the JSON object inside
const ERRORS_TAG_REGEX = /\{\{errors\s+(\{[^}]+\})\s*\}\}/gi;
/**
 * Parse content to find all error definition tags.
 * Returns extracted error mappings and content with error tags removed.
 */
export function parseErrors(content) {
    const errorTags = [];
    const errorMappings = {};
    ERRORS_TAG_REGEX.lastIndex = 0;
    let match;
    while ((match = ERRORS_TAG_REGEX.exec(content)) !== null) {
        const fullMatch = match[0];
        const jsonStr = match[1];
        const startIndex = match.index;
        const endIndex = startIndex + fullMatch.length;
        if (!jsonStr)
            continue;
        try {
            const mappings = JSON.parse(jsonStr);
            if (typeof mappings === "object" && mappings !== null) {
                errorTags.push({
                    original: fullMatch,
                    startIndex,
                    endIndex,
                    mappings,
                });
                // Merge into combined mappings (later values override earlier ones)
                Object.assign(errorMappings, mappings);
            }
        }
        catch {
            // Invalid JSON, skip this tag
            console.warn("Invalid JSON in {{errors ...}} tag:", jsonStr);
        }
    }
    // Remove error tags from content
    let processedContent = content;
    // Sort by startIndex descending to remove from end first
    const sortedTags = [...errorTags].sort((a, b) => b.startIndex - a.startIndex);
    for (const tag of sortedTags) {
        processedContent =
            processedContent.slice(0, tag.startIndex) +
                processedContent.slice(tag.endIndex);
    }
    return { content: processedContent, errorMappings, errorTags };
}
/**
 * Check if content contains any error definition tags.
 */
export function hasErrorTags(content) {
    ERRORS_TAG_REGEX.lastIndex = 0;
    return ERRORS_TAG_REGEX.test(content);
}
//# sourceMappingURL=errors.js.map